import { render } from "./StoreAllowancePolicy.vue?vue&type=template&id=0b9e7708&scoped=true"
import script from "./StoreAllowancePolicy.vue?vue&type=script&lang=js"
export * from "./StoreAllowancePolicy.vue?vue&type=script&lang=js"

import "./StoreAllowancePolicy.vue?vue&type=style&index=0&id=0b9e7708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9e7708"]])

export default __exports__